import React, { useContext, useState } from 'react';

export const AppCtx = React.createContext({});

export function AppProvider(props) {
  const [ alerts, setAlerts ] = useState([]);

  const [ fakeRole, setFakeRole ] = useState(null);

  const ctx = {
    alerts,
    setAlerts,
    fakeRole,
    setFakeRole,
  };

  return (
    <AppCtx.Provider value={ ctx }>
      {props.children}
    </AppCtx.Provider>
  );
}

export const useFakeRole = () => {
  const {
    fakeRole,
    setFakeRole,
  } = useContext(AppCtx);

  return {
    fakeRole,
    setFakeRole,
  };
};
